"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolSeer = exports.convertToBetEnum = void 0;
const anchor = __importStar(require("@project-serum/anchor"));
const constants_1 = require("./constants");
const getPDA_1 = require("./getPDA");
const numbers_1 = require("./numbers");
const wrappedSol_1 = require("./wrappedSol");
const interfaces_1 = require("./interfaces");
function convertToBetEnum(choice) {
    if (choice.up) {
        return interfaces_1.Bet.UP;
    }
    else if (choice.down) {
        return interfaces_1.Bet.DOWN;
    }
    else if (choice.draw) {
        return interfaces_1.Bet.DRAW;
    }
    else {
        throw new Error(`${choice} is not a proper enum`);
    }
}
exports.convertToBetEnum = convertToBetEnum;
let wrappedSolRent = 0;
class SolSeer {
    constructor(program, user, gameState, gameStateData) {
        this.program = program;
        this.user = user;
        this.gameState = gameState;
        this.gameStateData = gameStateData;
        this.roundDataPromises = {};
    }
    getWrappedSolRent() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wrappedSolRent) {
                wrappedSolRent = yield this.program.provider.connection.getMinimumBalanceForRentExemption(165);
            }
            return wrappedSolRent;
        });
    }
    getPDA(...seeds) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, getPDA_1.getPDA)(this.program, ...seeds);
        });
    }
    getPlayerBetHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            const [playerBetHistory] = yield this.getPDA(this.user, this.gameState);
            const data = yield this.program.account.playerBetHistory.fetch(playerBetHistory);
            return data;
        });
    }
    _closePlayerBetIx(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const [playerBetHistory] = yield this.getPDA(this.user, this.gameState);
            const [playerBetState] = yield this.getPDA(this.user, this.gameState, round.toString());
            const [roundState] = yield this.getPDA(this.gameState, round.toString());
            return this.program.instruction.closePlayerBet({
                accounts: {
                    playerBetHistory,
                    user: this.user,
                    roundState,
                    gameState: this.gameState,
                    playerBet: playerBetState,
                }
            });
        });
    }
    closePlayerBets(rounds) {
        return __awaiter(this, void 0, void 0, function* () {
            const ixs = [];
            for (let i = 0; i < rounds.length; i++) {
                const round = rounds[i];
                const ix = yield this._closePlayerBetIx(round);
                ixs.push(ix);
            }
            const tx = new anchor.web3.Transaction();
            tx.instructions = ixs;
            const res = yield this.program.provider.send(tx);
            return res;
        });
    }
    placeBet(params, createPlayerBetHistory, closeAccountParams) {
        return __awaiter(this, void 0, void 0, function* () {
            const [roundState] = yield this.getPDA(this.gameState, params.round.toString());
            const [playerBetHistory] = yield this.getPDA(this.user, this.gameState);
            const [playerBetState] = yield this.getPDA(this.user, this.gameState, params.round.toString());
            let bet = { draw: {} };
            if (params.bet === interfaces_1.Bet.UP) {
                bet = { up: {} };
            }
            else if (params.bet === interfaces_1.Bet.DOWN) {
                bet = { down: {} };
            }
            const amountBN = (0, numbers_1.Sol)(params.amount);
            const rentExemption = yield this.getWrappedSolRent();
            const { createWrappedSolIxs, wrappedSolAccount, closeTokenIxs } = (0, wrappedSol_1.wrappedSolInstructions)(this.user, amountBN, rentExemption);
            let preInstructions = createWrappedSolIxs;
            if (closeAccountParams) {
                const { closeRound, claimFirst } = closeAccountParams;
                if (claimFirst) {
                    const claimIx = yield this._claimsIx([closeRound], wrappedSolAccount.publicKey);
                    preInstructions.push(claimIx);
                }
                const closeIx = yield this._closePlayerBetIx(closeRound);
                preInstructions.push(closeIx);
            }
            if (createPlayerBetHistory) {
                preInstructions.push(this.program.instruction.createPlayerBetHistory({
                    accounts: {
                        playerBetHistory,
                        user: this.user,
                        gameState: this.gameState,
                        systemProgram: anchor.web3.SystemProgram.programId,
                    }
                }));
            }
            return this.program.rpc.createPlayerBet({
                round: params.round,
                choice: bet,
                amount: amountBN
            }, {
                accounts: {
                    oracleAccount: this.gameStateData.oracleAccount,
                    gameState: this.gameState,
                    gameVault: this.gameStateData.gameVault,
                    userTokenAccount: wrappedSolAccount.publicKey,
                    roundState: roundState,
                    playerBet: playerBetState,
                    playerBetHistory,
                    user: this.user,
                    systemProgram: anchor.web3.SystemProgram.programId,
                    tokenProgram: constants_1.TOKEN_PROGRAM_PUBLIC_KEY,
                },
                preInstructions: preInstructions,
                postInstructions: closeTokenIxs,
                signers: [wrappedSolAccount]
            });
        });
    }
    getBetAccount(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const [playerBetState] = yield this.getPDA(this.user, this.gameState, round.toString());
            const data = yield this.program.account.playerBet.fetch(playerBetState);
            return data;
        });
    }
    _claimsIx(rounds, wrappedSolAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            const [RoundStatePubkey] = yield this.getPDA(this.gameState, rounds[0].toString());
            const [playerBetState] = yield this.getPDA(this.user, this.gameState, rounds[0].toString());
            const [playerBetHistory] = yield this.getPDA(this.user, this.gameState);
            const remainingAccounts = [];
            for (let i = 1; i < rounds.length; i++) {
                const [RoundStatePubkey] = yield this.getPDA(this.gameState, rounds[i].toString());
                const [playerBetState] = yield this.getPDA(this.user, this.gameState, rounds[i].toString());
                remainingAccounts.push({ pubkey: playerBetState, isWritable: true, isSigner: false }, { pubkey: RoundStatePubkey, isWritable: true, isSigner: false });
            }
            return this.program.instruction.claim({
                accounts: {
                    gameState: this.gameState,
                    gameVault: this.gameStateData.gameVault,
                    userTokenAccount: wrappedSolAccount,
                    roundState: RoundStatePubkey,
                    playerBetHistory,
                    playerBet: playerBetState,
                    user: this.user,
                    systemProgram: anchor.web3.SystemProgram.programId,
                    tokenProgram: constants_1.TOKEN_PROGRAM_PUBLIC_KEY,
                },
                remainingAccounts: remainingAccounts,
            });
        });
    }
    claims(rounds) {
        return __awaiter(this, void 0, void 0, function* () {
            const rentExemption = yield this.getWrappedSolRent();
            const { createWrappedSolIxs, wrappedSolAccount, closeTokenIxs } = (0, wrappedSol_1.wrappedSolInstructions)(this.user, new anchor.BN(0), rentExemption);
            const ixs = [...createWrappedSolIxs];
            const ix = yield this._claimsIx(rounds, wrappedSolAccount.publicKey);
            ixs.push(ix);
            ixs.push(...closeTokenIxs);
            const tx = new anchor.web3.Transaction();
            tx.instructions = ixs;
            const res = yield this.program.provider.send(tx, [wrappedSolAccount]);
        });
    }
    advance(currentRound) {
        return __awaiter(this, void 0, void 0, function* () {
            const [currentRoundState] = yield this.getPDA(this.gameState, currentRound.toString());
            const [nextRoundState] = yield this.getPDA(this.gameState, (currentRound + 1).toString());
            const [nextNextRoundState] = yield this.getPDA(this.gameState, (currentRound + 2).toString());
            const rentExemption = yield this.getWrappedSolRent();
            const { createWrappedSolIxs, wrappedSolAccount, closeTokenIxs } = (0, wrappedSol_1.wrappedSolInstructions)(this.user, new anchor.BN(0), rentExemption);
            // TODO: Check if user has made the bet
            const playerBetPDA = yield this.getBetPDA(currentRound);
            yield this.program.rpc.advance({
                currentRound
            }, {
                accounts: {
                    oracleAccount: this.gameStateData.oracleAccount,
                    gameState: this.gameState,
                    gameVault: this.gameStateData.gameVault,
                    userTokenAccount: wrappedSolAccount.publicKey,
                    currentRoundState: currentRoundState,
                    nextRoundState: nextRoundState,
                    nextNextRoundState: nextNextRoundState,
                    user: this.user,
                    systemProgram: anchor.web3.SystemProgram.programId,
                    tokenProgram: constants_1.TOKEN_PROGRAM_PUBLIC_KEY,
                },
                remainingAccounts: [
                    { pubkey: playerBetPDA, isWritable: false, isSigner: false },
                ],
                signers: [wrappedSolAccount],
                preInstructions: createWrappedSolIxs,
                postInstructions: closeTokenIxs
            });
        });
    }
    getBetPDA(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const [playerBetState] = yield this.getPDA(this.user, this.gameState, round.toString());
            return playerBetState;
        });
    }
    getRoundPDA(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const [RoundPubkey] = yield this.getPDA(this.gameState, round.toString());
            return RoundPubkey;
        });
    }
    getVaultBalance() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const accountInfo = yield this.program.provider.connection.getParsedAccountInfo(this.gameStateData.gameVault, 'recent');
            let tokenInfo = {
                amount: '0',
                decimals: 0,
                uiAmount: 0,
                uiAmountString: '0',
            };
            if (accountInfo.value) {
                tokenInfo = (_c = (_b = (_a = accountInfo.value.data) === null || _a === void 0 ? void 0 : _a.parsed) === null || _b === void 0 ? void 0 : _b.info) === null || _c === void 0 ? void 0 : _c.tokenAmount;
            }
            return tokenInfo;
        });
    }
    getRoundData(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const [roundState] = yield this.getPDA(this.gameState, round.toString());
            if (!this.roundDataPromises[round]) {
                this.roundDataPromises[round] = this.program.account.roundState.fetch(roundState);
            }
            const dataPromise = this.roundDataPromises[round];
            const data = yield dataPromise;
            return data;
        });
    }
    getExpectedRewards(round, amount, bet) {
        return __awaiter(this, void 0, void 0, function* () {
            const roundData = yield this.getRoundData(round);
            const total = roundData.totalBetDown.add(roundData.totalBetUp).add(roundData.totalBetDraw);
            let poolSize = roundData.totalBetDraw;
            if (bet === interfaces_1.Bet.UP) {
                poolSize = roundData.totalBetUp;
            }
            else if (bet === interfaces_1.Bet.DOWN) {
                poolSize = roundData.totalBetDown;
            }
            const amountBN = (0, numbers_1.Sol)(amount);
            const totalPlusContribution = total.add(amountBN);
            const reward = totalPlusContribution.mul(amountBN).div(poolSize.add(amountBN));
            const fee = reward.mul(new anchor.BN(this.gameStateData.feeRateBips)).div(new anchor.BN(10000));
            const rewardAfterFee = reward.sub(fee);
            return [rewardAfterFee, fee];
        });
    }
    calcPayoutRatioBips(betPool, totalPool) {
        if (betPool.eq(new anchor.BN(0))) {
            return 10000;
        }
        else {
            return totalPool.mul(new anchor.BN(100)).div(betPool).toNumber();
        }
    }
    getPayoutRatios(round) {
        return __awaiter(this, void 0, void 0, function* () {
            const roundData = yield this.getRoundData(round);
            const total = roundData.totalBetDown.add(roundData.totalBetUp).add(roundData.totalBetDraw);
            return {
                up: this.calcPayoutRatioBips(roundData.totalBetUp, total),
                down: this.calcPayoutRatioBips(roundData.totalBetDown, total),
                draw: this.calcPayoutRatioBips(roundData.totalBetDraw, total)
            };
        });
    }
    getGameState() {
        return __awaiter(this, void 0, void 0, function* () {
            this.gameStateData = (yield this.program.account.gameState.fetch(this.gameState));
            return this.gameStateData;
        });
    }
    adminClaimFees() {
        return __awaiter(this, void 0, void 0, function* () {
            const rentExemption = yield this.getWrappedSolRent();
            const [mainStatePubkey] = yield this.getPDA(constants_1.MAIN_STATE);
            const { createWrappedSolIxs, wrappedSolAccount, closeTokenIxs } = (0, wrappedSol_1.wrappedSolInstructions)(this.user, new anchor.BN(0), rentExemption);
            yield this.program.rpc.claimFees({
                accounts: {
                    mainState: mainStatePubkey,
                    adminAuthority: this.user,
                    gameState: this.gameState,
                    gameVault: this.gameStateData.gameVault,
                    userTokenAccount: wrappedSolAccount.publicKey,
                    systemProgram: anchor.web3.SystemProgram.programId,
                    tokenProgram: constants_1.TOKEN_PROGRAM_PUBLIC_KEY,
                },
                signers: [wrappedSolAccount],
                preInstructions: createWrappedSolIxs,
                postInstructions: closeTokenIxs
            });
        });
    }
    adminUpdateGameState(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const [mainStatePubkey] = yield this.getPDA(constants_1.MAIN_STATE);
            yield this.program.rpc.updateGameState({
                advanceMinBalanceRequired: params.advanceMinBalanceRequired || null,
                minBetAmount: params.minBetAmount || null,
                intervalPeriod: params.intervalPeriod || null,
                feeRateBips: params.feeRateBips || null,
                advanceReward: params.advanceReward || null,
                earlyAdvanceThreshold: params.earlyAdvanceThreshold || null,
                advanceThreshold: params.advanceThreshold || null,
                earlyAdvanceAmountRequirement: params.earlyAdvanceAmountRequirement || null,
                minTotalRequired: params.minTotalRequired || null,
                decimalPlaces: params.decimalPlaces || null
            }, {
                accounts: {
                    mainState: mainStatePubkey,
                    gameState: this.gameState,
                    adminAuthority: this.user
                }
            });
        });
    }
}
exports.SolSeer = SolSeer;
